import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { buttonVariants } from '@mdvip/shared/components/ui/button';
import { cn } from '@mdvip/shared/lib/utils';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { MemberContextBar } from '@/components/members/MemberContextBar';
import { MemberSwitcher } from '@/components/members/MemberSwitcher';
import { SelectMemberModal } from '@/components/members/SelectMemberModal';

export function AwpProgramPage() {
  const { t } = useTranslation('providers');

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 flex-1">
          <h1 className="text-h2 font-semibold tracking-tight text-foreground">{t('pages.awp.title')}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{t('pages.awp.subtitle')}</p>
        </div>
        {/* `self-start`: a flex-col parent stretches its children by default, which would otherwise
            blow this pill-shaped row out to the full page width while stacked. */}
        <div className="flex shrink-0 flex-wrap items-center gap-2 self-start">
          {/* A real destination, so it stays a link and only borrows the button's styling — routing
              it through Button instead would have Base UI stamp `role="button"` onto the anchor. */}
          <Link to="/patients" className={cn(buttonVariants({ variant: 'outline' }), 'gap-2')}>
            <Icon name="layoutGrid" size="sm" />
            {t('pages.awp.viewAllPatients')}
            <Icon name="arrowRight" size="xs" />
          </Link>
          {/* A real destination, so it stays a link and only borrows the button's styling — same
              reasoning as "View all patients" above. */}
          <Link to="/resources" className={cn(buttonVariants({ variant: 'outline' }), 'gap-2')}>
            <Icon name="bookOpen" size="sm" />
            {t('pages.awp.awpResources')}
          </Link>
        </div>
      </div>

      <MemberContextBar switcher={<MemberSwitcher />} />
      <SelectMemberModal />
    </div>
  );
}
